<template>
  <CCard>
    <CCardHeader>
      <b>Credits outstanding</b>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        hover
        striped
        border
        sorter
        :items="datas"
        :fields="fields"
        :items-per-page="25"
        :pagination="{ doubleArrows: false, align: 'center' }"
      >
        <td slot="from_to" slot-scope="{ item }">
          {{ item.from_to }}
        </td>
        <td slot="total" slot-scope="{ item }">
          {{ item.total_amount | currency100 }}
        </td>
        <td slot="change" slot-scope="{ item }">
          {{ item.change_amount | currency100 }}
        </td>

        <template #show_details="{ item, index }">
          <td class="py-2">
            <CButton
              color="primary"
              variant="outline"
              square
              size="sm"
              @click="toggleDetails(item, index)"
            >
              {{ Boolean(datas[index]._toggled) ? 'Hide' : 'Show' }}
            </CButton>
          </td>
        </template>
        <template #details="{ item, index }">
          <CCollapse
            :show="Boolean(datas[index]._toggled)"
            :duration="collapseDuration"
          >
            <CreditsOutstandingDetails :items="item.credit_outstanding" />
          </CCollapse>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
import AdminProxy from '@/proxies/admin.proxy';
import CreditsOutstandingDetails from '@/components/CreditsOutstandingDetails.vue';

export default {
  components: {
    CreditsOutstandingDetails,
  },
  data() {
    return {
      datas: [],
      fields: [
        { key: 'from_to', label: 'From to' },
        { key: 'total', label: 'Total' },
        { key: 'change', label: 'Change' },
        {
          key: 'show_details',
          label: '',
          _style: 'width:1%',
          sorter: false,
          filter: false,
        },
      ],
      collapseDuration: 0,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      const { data } = await AdminProxy.getFinanceCreditsOutstanding();
      this.datas = data || [];
    },
    toggleDetails(item, index) {
      this.$set(this.datas[index], '_toggled', !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },
  },
};
</script>
